import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { of } from 'rxjs';
import { catchError, concatMap, map, mergeMap, switchMap, tap } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';

import { State } from '../../vista-usuario/vista-usuario.state';
import {
  entityRolAddFailure,
  entityRolAddRequest,
  entityRolAddSuccess,
  entityRolChangeFailure,
  entityRolChangeRequest,
  entityRolChangeSuccess,
  entityRolDeleteRequest,
  entityRolDeleteSuccess,
  entityRolLoadFailure,
  entityRolLoadRequest,
  entityRolLoadSuccess
} from './entity-roles.actions';

import { Update } from '@ngrx/entity';
import { RolService } from './roles.service';
import { Rol } from './roles.model';
import {
  entityPersonasJuridicaAddSuccess,
  entityPersonasJuridicaChangeSuccess
} from '../../empresas/entity-personas-juridica/entity-personas-juridica.actions';
import { entityPersonasFisicaAddSuccess } from '../../empresas/entity-personas-fisica/entity-personas-fisica.actions';
import { entityIntegranteAddSuccess } from '../entity-integrante/entity-integrante.actions';
import { NotificationService } from '../../../core/core.module';
import { entityPersonasChangeRequestWithoutRedirection } from './../../persona/entity-personas/entity-personas.actions';

@Injectable()
export class RolEffects {
  // load
  loadRequestRol = createEffect(() =>
    this.actions$.pipe(
      ofType(
        entityRolLoadRequest,
      ),
      mergeMap(() =>
        this.rolService.getRoles().pipe(
          // TODO luego cambiar a getroles
          map((items) => {
            const roles = items.map((rol: Rol) => {
              if (rol.acreditacion_representacion !== null) {
                // Agregar la cadena solo si acreditacion_representacion no es nulo
                return {
                  ...rol,
                  acreditacion_representacion: `${'https://' +
                    environment.hostBackend +
                    rol.acreditacion_representacion
                    }` as any
                };
              } else {
                return rol; // Mantener el objeto sin cambios si acreditacion_representacion es nulo
              }
            });
            return entityRolLoadSuccess({ items: roles });
          }),
          catchError((error) => of(entityRolLoadFailure({ error })))
        )
      )
    )
  );

  // add
  addRequestRol = createEffect(() =>
    this.actions$.pipe(
      ofType(entityRolAddRequest),
      switchMap((action) =>
        this.rolService.addRol(action.item).pipe(
          map((item) => entityRolAddSuccess({ item })),
          catchError((error) => of(entityRolAddFailure({ error })))
        )
      )
    )
  );

  addSuccessRolRegistroEntidadProductiva = createEffect(() =>
    this.actions$.pipe(
      ofType(
        entityPersonasJuridicaAddSuccess,
        entityPersonasFisicaAddSuccess,
        entityIntegranteAddSuccess
      ),
      map((action) => entityRolAddSuccess({ item: action.item.rol })),
      catchError((error) => of(entityRolAddFailure({ error })))
    )
  );

  deleteSuccessRolRegistroEntidadProductiva = createEffect(() =>
    this.actions$.pipe(
      ofType(entityRolDeleteRequest),
      switchMap((action) => {
        return this.rolService.deleteRol(action.item.rol).pipe(
          map(() => entityRolDeleteSuccess({ item: action.item.rol })),
          //map(() => entityIntegranteDeleteSuccess({ item: action.item })),
          catchError((error) => of(entityRolAddFailure({ error })))
        );
      })
    )
  );

  /*addSuccessRol = createEffect(
    () =>
      this.actions$.pipe(
        ofType(entityRolAddSuccess),
        tap(() => this.router.navigate(['']))
      ),
    { dispatch: false }
  );*/

  // change
  changeRequestRol = createEffect(() =>
    this.actions$.pipe(
      ofType(entityRolChangeRequest),
      mergeMap((action) =>
        this.rolService.changeRol(action.item).pipe(
          map((itemaux: Rol) => {
            let item = itemaux;

            if (itemaux.acreditacion_representacion !== null) {
              // Agregar la cadena solo si acreditacion_representacion no es nulo
              item = {
                ...itemaux,
                acreditacion_representacion: `${'https://' +
                  environment.hostBackend +
                  itemaux.acreditacion_representacion
                  }` as any
              };
            } else {
              item = itemaux; // Mantener el objeto sin cambios si acreditacion_representacion es nulo
            }

            return entityRolChangeSuccess({ item: item })
          }),
          concatMap((successAction) => [
            successAction,
            ...(action.persona ? [entityPersonasChangeRequestWithoutRedirection({ item: action.persona as any })] : [])
          ]),
          catchError((error) => of(entityRolChangeFailure({ error })))
        )
      )
    )
  );

  rolChangeSuccess = createEffect(
    () =>
      this.actions$.pipe(
        ofType(entityRolChangeSuccess),
        tap(() => {
          this.alert.success('Rol actualizado correctamente');
        })
      ),
    { dispatch: false }
  );

  rolChangeSuccessByPersonaJuridicaSuccess = createEffect(
    () =>
      this.actions$.pipe(
        ofType(entityPersonasJuridicaChangeSuccess),
        map((result) => entityRolChangeSuccess({ item: result.item.rol }))
      ),
    { dispatch: false }
  );

  // delete

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private rolService: RolService,
    private router: Router,
    private alert: NotificationService
  ) {
    this.rolService.url = environment.apiUrl;
  }
}
